<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const router = useRouter();
const store = useStore();

onMounted(() => {
  const user = store.getters.getCurrentUser;
  const accountId = user?.account_id || user?.accounts?.[0]?.id;

  if (accountId) {
    router.replace({
      name: 'planning_calendar',
      params: { accountId },
    });
  } else {
    router.replace('/app');
  }
});
</script>

<template>
  <div class="flex items-center justify-center h-full">
    <div class="i-lucide-loader-2 size-8 animate-spin text-n-secondary" />
  </div>
</template>
